import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  left: {
    margin: "0 11px 0 0",
  },
  right: {
    margin: "0 0 0 11px",
  },
  center: {
    margin: "0",
    alignSelf: "center",
  },
  root: {
    color: colors.black,
    border: `1px solid ${colors.black}`,
    borderRadius: "4px",
    backgroundColor: theme.palette.grey[100],
  },
  label: {
    textTransform: "capitalize",
  },
  deleteIcon: {
    padding: 2,
  },
  colorPrimary: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: "#E7F2FE",
  },
  colorSecondary: {
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: "#F5FCF8",
  },
  colorError: {
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
    backgroundColor: "#FEF4F3",
  },
  colorWarn: {
    color: theme.palette.warning.main,
    border: `1px solid ${theme.palette.warning.main}`,
    backgroundColor: "#FEF8F4",
  },
}));

export default useStyles;
